/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { getAllUsers } from '../../../../../Redux/users/usersSlice'
import { togglePopup } from '../../../../../Redux/popups/popupSlice'
import { useTranslation } from 'react-i18next'
import { collection, getDocs, query, where } from 'firebase/firestore'
import { firestore } from '../../../../../config/firebase'

const Index = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const { users, loading, error } = useSelector((state) => state.users)
  const auth = useSelector((state) => state.auth)
  const { profile } = auth?.user || {}
  const isAdmin = profile?.role === 'admin'
  const [displayUsers, setDisplayUsers] = useState([])

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        if (isAdmin) {
          // For admin users, use the Redux action
          await dispatch(getAllUsers()).unwrap()
        } else {
          // For standard users, try to fetch users directly
          const usersCollection = collection(firestore, 'users')
          const q = query(usersCollection)
          const querySnapshot = await getDocs(q)
          const usersList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
          setDisplayUsers(usersList)
        }
      } catch (error) {
        console.error('Error fetching users:', error)
        // If direct fetch fails, at least show the current user
        setDisplayUsers([{
          id: profile?.uid,
          displayName: profile?.displayName,
          role: profile?.role,
          ...profile
        }])
      }
    }
    fetchUsers()
  }, [dispatch, isAdmin, profile])

  const toggleUserAddingPopup = () => {
    if (!isAdmin) return
    dispatch(
      togglePopup({
        pointer: 1,
        data: null
      })
    )
  }

  const toggleEditUser = (user) => {
    if (!isAdmin) return
    dispatch(
      togglePopup({
        pointer: 1,
        data: user
      })
    )
  }

  const toggleDeleteUser = (user) => {
    if (!isAdmin) return
    dispatch(
      togglePopup({
        pointer: 1,
        data: { ...user, deleteData: true }
      })
    )
  }

  if (loading) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.loading}>Loading employees...</div>
      </div>
    )
  }

  if (error && isAdmin) {
    return (
      <div className={styles.wrapper}>
        <div className={styles.error}>Error loading employees: {error}</div>
      </div>
    )
  }

  const usersToDisplay = isAdmin ? users : displayUsers

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        <h2 className={styles.user_list_caption}>{t('employees_list')}</h2>
        {isAdmin && (
          <button className={`${styles.add_user}`} onClick={toggleUserAddingPopup}>
            {t('add_new_employee')}
          </button>
        )}
      </div>
      <div className={styles.users_list}>
        {usersToDisplay && usersToDisplay.length > 0 ? (
          usersToDisplay.map((user) => (
            <div key={user.id} className={styles.user_card}>
              <div className={styles.user_info}>
                <p className={styles.user_name}>
                  {user.displayName} <span className={styles.role}>{`(${user.role})`}</span>
                </p>
              </div>
              {isAdmin && (
                <div className={styles.user_control}>
                  <button className={`${styles.manage_button}`} onClick={() => toggleEditUser(user)}>
                    {t('edit')}
                  </button>
                  <pre className={styles.seperator} />
                  <button className={`${styles.manage_button} ${styles.delete_btn}`} onClick={() => toggleDeleteUser(user)}>
                    {t('delete')}
                  </button>
                </div>
              )}
            </div>
          ))
        ) : (
          <div className={styles.no_users}>
            <p>No employees found</p>
            <p className={styles.no_users_subtext}>
              {isAdmin 
                ? 'Please make sure you have created employees in the system.'
                : 'You can only view your own profile as a standard user.'}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default Index
